import React from "react";
import Select from "react-select";

export const ReactSelectAdapter = ({ input, disabled, defaultValue, ...rest }) => {
  if (disabled) {
    return <span className='form-control-plaintext mb-4'>{input.value.label}</span>;
  } else {
    return <Select {...input} {...rest} isSearchable />;
  }
};
